import { render } from "./SidenavCollapse.vue?vue&type=template&id=80dc1f72&scoped=true"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=80dc1f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dc1f72"]])

export default __exports__